import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StaticDataApiService {
  public itimMinistryTracks = [
    {
      moduleId: 'ZRTG2243D',
      mainModuleName: 'Discipleship',
      detailpage: {
        Heading: 'Discipleship Track',
        Id:1,
        Data: `<p>Each course in the Discipleship track has a practicum associated with it. This is especially true of&nbsp;<a [routerLink]="['/Christianity101']">Christianity 101</a>, which becomes every learner’s tool to disciple others.</p>
        `,
        links: [
          {
            bookPageID: '2ASHJD@',
            linkName: 'Christianity101',
            name: 'Christianity 101',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) teaches the basics of the Christian faith, including conversion, baptism, and participation in the life of the church. Outcome: This course will equip learners to  lead others through Christianity 101.',
            bookDetails: {
              bookHeading: 'Christianity 101',
              bookDescription: `This 12 lesson course covers the basics of the Christian faith. Learners will not only learn these basic Christian truths, but also to become involved in the local church. Christianity 101 requires an hour of personal study per lesson, plus involvement in group interaction.  Learners are challenged use this course to disciple another person and to begin their own ministry of discipling. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/christianity-101-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/2',
              buyHardCopyLink: 'http://thebp.net/12961',
              samplePDFLink: '../../../assets/Pdf/christianity-101.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16942',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-christianity-101.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the guidance provided in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '2BSHJD@',
            linkName: 'Outreach as a Lifestyle',
            name: 'Outreach as a Lifestyle',
            linkUrl: '',
            linkDescription:
              ' Jesus said in Acts 1:8b: "And you shall be witnesses to Me in Jerusalem, and in all Judea and Samaria, and to the end of the earth”. This 12 lesson course will train people in how to develop friendships which will lead to sharing Christ with them.',
            bookDetails: {
              bookHeading: 'Outreach as a Lifestyle',
              bookDescription: `This 12 lesson course is a discipleship course for youth. It covers the basics of the Christian faith and the importance of the local church. Christianity 101 is designed for personal study prior to group interaction and application. Young people who take this course are encouraged to use this course to personally disciple another person. It is a part of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/outreach-as-a-life-style-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/8',
              buyHardCopyLink: 'http://thebp.net/14140',
              samplePDFLink: '../../../assets/Pdf/outreach-as-a-life-style.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/343479',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-outreach-as-a-life-style.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '2CSHJD@',
            linkName: 'A-Panorama-of-the-Bible',
            name: 'A Panorama of the Bible',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) is an overview study of the entire Bible. It includes easy-to-remember visuals that enable learners to remember both the content, and the main message of the Bible. Outcome: Learner’s are encouraged to teach this course to others.',
            bookDetails: {
              bookHeading: 'A Panorama of the Bible',
              bookDescription: `This 12 lesson course will teach learners the “big picture” of Bible content. It uses easy-to-remember symbols to help recall the content of each Bible period.  A Panorama of the Bible is  is designed for group study in the iTIM series of equipping courses. It is designed for personal study of each lesson of an hour or more, plus group interaction and application. It is a foundational Bible study course needed by all believers.`,
              bookImageURl:
                '../../../assets/images/a-panorama-of-the-bible-5-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/3',
              buyHardCopyLink: 'http://thebp.net/79917',
              samplePDFLink: '../../../assets/Pdf/a-panorama-of-the-bible.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16933',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-a-panorama-of-the-bible.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '2DSHJD@',
            linkName: 'Learning-to-Serve-Jesus-as-Role-Model',
            name: 'Learning to Serve: Jesus as Role Model',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) teaches the basics of the Christian faith, including conversion, baptism, and participation in the life of the church. Outcome: This course will equip learners to  lead others through Christianity 101.(12 lessons) teaches the servant life-style of Jesus. Outcome: This study will help learners put servant leadership into practice.',
            bookDetails: {
              bookHeading: 'Learning to Serve: Jesus as Role Model',
              bookDescription: `This 12 lesson course teaches the servant life-style of Jesus and encourages learners to model Jesus in their own life style and ministry.  Learning to Serve: Jesus as Role Model is designed for personal study plus group interaction and application.  It is  is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/learning-to-serve-jesus-as-role-model-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/4',
              buyHardCopyLink: 'http://thebp.net/12970',
              samplePDFLink:
                '../../../assets/Pdf/learning-to-serve-jesus-as-role-model.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/112440',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-learning-to-serve-jesus-as-role-model.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who has carefully studied both the learner’s lesson for the week, and the lesson in the Leader’s Guide.',
            },
          },
        ],
      },
    },

    {
      moduleId: 'ZRTG2243E',
      mainModuleName: 'Church-Ministry',
      detailpage: {
        Heading: 'Church Ministry Track',
        Id:2,
        Data: `<p>The Church Ministry track is designed to equip workers in the ministry of the local church. An iTIM <strong>Certificate</strong> may be awarded to learners for completing each of these courses. </p>`,
        links: [
          {
            bookPageID: '3ASHJD@',
            linkName: 'Welcome-to-Your-Ministry',
            name: 'Welcome to Your Ministry',
            linkUrl: '',
            linkDescription:
              ' teaches learners that God has given all believers the title and the resources of a minister, and has called them to become involved in ministry in and through the church. Outcome: Learners will be challenged to become good stewards of their time and talents and become better equipped to serve Christ.',
            bookDetails: {
              bookHeading: 'Welcome to Your Ministry',
              bookDescription: `This 12 lesson course teaches the important truth that God calls all Christians into ministry and encourages their involvement in ministry. Welcome to Your Ministry is designed for an hour of personal study per lesson, followed by participation in a weekly group meeting that features discussion and application of the lesson.   It is one of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/welcome-to-your-ministry-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/5',
              buyHardCopyLink: 'http://thebp.net/12007',
              samplePDFLink: '../../../assets/Pdf/welcome-to-your-ministry.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/346318',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-welcome-to-your-ministry.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who has carefully studied both the lesson for the week, and the related lesson material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3BSHJD@',
            linkName: 'How-to-Discover-Your-Spiritual-Gifts',
            name: 'How to Discover Your Spiritual Gifts',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) is a study of the spiritual gifts taught in the New Testament. Outcome: Learners will discover or become more confident of their own gifts, and how and where to use them in service for Christ.',
            bookDetails: {
              bookHeading: 'How to Discover Your Spiritual Gifts',
              bookDescription: `This 12 lesson course will help learners both to understand the spiritual gifts mentioned in the Bible and to discover the gifts that they have been given. Learners need to commit to an hour of personal study of each lesson, followed by group discussion and application. Learners will seek opportunities to further develop their gifts, and use them for God’s purposes.`,
              bookImageURl:
                '../../../assets/images/how-to-discover-your-spirtual-gifts-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/6',
              buyHardCopyLink: 'http://thebp.net/12963',
              samplePDFLink:
                '../../../assets/Pdf/how-to-discover-your-spirtual-gifts.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16925',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-how-to-discover-your-spirtual-gifts.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking this course. This group study should be led by a qualified leader who has carefully studied the lesson for the week, as well as the guidance provided in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3CSHJD@',
            linkName: 'Your-Ministry-of-Prayer',
            name: 'Your Ministry of Prayer',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) studies prayer in Scripture and will guide learners into a significant ministry of prayer. Outcome: Learners will commit to a significant and ongoing ministry of prayer.',
            bookDetails: {
              bookHeading: 'Your Ministry of Prayer',
              bookDescription: `Your Ministry of Prayer will help learners understand much more about the purpose and power of prayer, and set them on a course of a significant prayer ministry. This 12 lesson course is designed for a hour of personal study per lesson, followed by group interaction and application.  It  is a part of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/your-ministry-of-prayer-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/7',
              buyHardCopyLink: 'http://thebp.net/12969',
              samplePDFLink: '../../../assets/Pdf/your-ministry-of-prayer.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16936',
              leaderSamplePDFlink:
                'h../../../assets/Pdf/lg-your-ministry-of-prayer.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader who has carefully studied both the lesson for the week, and the relate material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3DSHJD@',
            linkName: 'Outreach-as-a-Life-style',
            name: 'Outreach as a Life-style',
            linkUrl: '',
            linkDescription:
              ' Jesus said in Acts 1:8b: "And you shall be witnesses to Me in Jerusalem, and in all Judea and Samaria, and to the end of the earth”. This 12 lesson course will train people in how to develop friendships which will lead to sharing Christ with them.',
            bookDetails: {
              bookHeading: 'Outreach as a Life-style',
              bookDescription: `Outreach as a Life-style leads learners to build relationships with people that in turn lead to the effectivde sharing of the Good News of Christ.  This 12 lesson course requires an hour per lesson of individual study, followed by a weekly group interaction and application of the lesson. It is  is part of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/outreach-as-a-life-style-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/8',
              buyHardCopyLink: 'http://thebp.net/14140',
              samplePDFLink: '../../../assets/Pdf/outreach-as-a-life-style.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/343479',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-outreach-as-a-life-style.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3ESHJD@',
            linkName: 'Your-Ministry-at-Home',
            name: 'Your Ministry at Home',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) provides practical principles in how to establish and maintain a Christian home. Outcome: Learners will apply the principles within the learner’s family, and lead others through this course.',
            bookDetails: {
              bookHeading: 'Your Ministry at Home',
              bookDescription: `This 12 lesson course provides a wealth of “how to” suggestions regarding the various topics of what a Christian home is to look like.   This 12 lesson course is designed for an hour of personal study per lesson, followed by a weekly group meeting of group interaction and application.   It is  a part of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/your-ministry-at-home-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/5',
              buyHardCopyLink: 'http://thebp.net/11805',
              samplePDFLink: '../../../assets/Pdf/your-ministry-at-home.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16917',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-your-ministry-at-home.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who has carefully studied both the lesson for the week, and the related material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3FSHJD@',
            linkName: 'Touching-Tomorrow-by-Teaching-Children',
            name: 'Touching Tomorrow by Teaching Children',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) will train learners to develop friendships with people that will lead to sharing Christ with them. Outcome: Learners will build this evangelism approach into their daily lives and ministry.',
            bookDetails: {
              bookHeading: 'Touching Tomorrow by Teaching Children',
              bookDescription: `Outreach as a Life-style leads learners to build relationships with people that in turn lead to the effectivde sharing of the Good News of Christ. This 12 lesson course requires an hour per lesson of individual study, followed by a weekly group interaction and application of the lesson. It is is part of the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/touching-tomorrow-by-teaching-children-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/16',
              buyHardCopyLink: 'http://thebp.net/12972',
              samplePDFLink:
                '../../../assets/Pdf/touching-tomorrow-by-teaching-children.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16939',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-touching-tomorrow-by-teaching-children.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '3GSHJD@',
            linkName: 'Christianity-in-the-Workplace',
            name: 'Christianity in the Workplace',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) relates faith to ethical and practical issues on the job. Its focus is on how to reflect Christ in their work world. Outcome: Learners will apply these biblical principles to their areas of work.',
            bookDetails: {
              bookHeading: 'Christianity in the Workplace',
              bookDescription: `Christianity in the Workplace relates faith to the many ethical and practical issues often experienced in the world of work. This course will help learners be like Christ in their work environment. This 12 lesson course is designed for personal study plus group interaction and application. A Leader’s Guide is available for group study. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/christianity-in-the-workplace-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/10',
              buyHardCopyLink: 'http://thebp.net/13389',
              samplePDFLink:
                '../../../assets/Pdf/christianity-in-the-workplace.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16941',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-christianity-in-the-workplace.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
        ],
      },
    },

    {
      moduleId: 'ZRTG2243F',
      mainModuleName: 'Church-Leadership',
      detailpage: {
        Heading: 'Church Leadership',
        Id:3,
        Data: `<p>The Church Leadership Track is designed for those who are or who desire to become leaders in their local church. Each course has a ministry practicum associated with it.</p>`,
        links: [
          {
            bookPageID: '3ASHJD@',
            linkName: 'Equipping-for-Leadership',
            name: 'Equipping for Leadership',
            linkUrl: '',
            linkDescription:
              ' This 12 lesson course will equip your leaders and potential leaders for effective leadership in the church.  Equipping for Leadership requires an hour of personal study of each lesson, plus group interaction and application.',
            bookDetails: {
              bookHeading: 'Equipping for Leadership',
              bookDescription: `This 12-lesson course in church leadership will train church leaders and potential church leaders for a more effective ministry in the church. Equipping for Leadership is designed for one hour of personal study per lesson, plus a weekly iTIM group meeting. Learners who complete this course will become more effective in their leadership ministry in the church. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/equipping-for-leadership-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink:
                'https://onlinecourses.traininginministry.com/course-detail/11',
              buyHardCopyLink: 'http://thebp.net/11899',
              samplePDFLink: '../../../assets/Pdf/equipping-for-leadership.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader who carefully studies the lesson for each week.',
            },
          },
          {
            bookPageID: '3BSHJD@',
            linkName: 'Truth-That-Transforms',
            name: 'Truth That Transforms',
            linkUrl: '',
            linkDescription:
              ' This 12 lesson course provides a solid foundation in the major Bible doctrines. It also emphasizes practical applications of these truths. Truth That Transforms is designed for personal study, followed by  a weekly meeting of group interaction and application.',
            bookDetails: {
              bookHeading: 'Truth That Transforms',
              bookDescription: `This 12 lesson course provides a solid foundation in the major Bible doctrines, and emphasizes practical applications of these truths. Truth That Transforms is designed for an hour or more in personal study of each lesson, followed by a weekly group meeting that features a discussion and application of each lesson. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/truth-that-transforms-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/12',
              buyHardCopyLink: 'http://thebp.net/13976',
              samplePDFLink: '../../../assets/Pdf/truth-that-transforms.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16940',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-truth-that-transforms.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who has carefully studied both the lesson for the week, and the lesson related guidance in the Leader’s Guide.',
            },
          },
        ],
      },
    },

    {
      moduleId: 'ZRTG2244E',
      mainModuleName: 'BibleTeaching',
      detailpage: {
        Heading: 'Bible Teaching Track',
        Id:4,
        Data: `<p>The Bible Teaching track is for learners who desire to become Bible teachers. Each course has a ministry practicum associated with it, so earners will be teaching the material in these courses to others.</p>`,
        links: [
          {
            bookPageID: '2ASHJ5S',
            linkName: 'a-survey-of-the-new-testament',
            name: 'A Survey of the New Testament',
            linkUrl: '',
            linkDescription:
              ' (24 lessons) includes background information, the main idea of each book, an outline of each book, and questions of practical and spiritual value. Outcome: Learners will be equipped to lead Bible studies in any New Testament book.',
            bookDetails: {
              bookHeading: 'A Survey of the New Testament',
              bookDescription: `This 24-lesson Survey of the New Testament includes basic outlines of each book, background information for each book, and questions to be answered. Learners who complete this study will be qualified to lead Bible studies in any New Testament book. It is  is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/a-survey-of-the-new-testament-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/19',
              buyHardCopyLink: 'http://thebp.net/242234',
              samplePDFLink:
                '../../../assets/Pdf/a-survey-of-the-new-testament.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/246437',
              leaderSamplePDFlink: '',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the material in the Leader’s Guide.',
            },
          },
          {
            bookPageID: '2ASHJFB',
            linkName: 'a-survey-of-the-old-testament',
            name: 'A Survey of the Old Testament',
            linkUrl: '',
            linkDescription:
              ' (24 lessons) includes background information, the main idea of each book, an outline of each book, and questions of practical and spiritual value. Outcome: Learners will be equipped to lead Bible studies in any Old Testament book.',
            bookDetails: {
              bookHeading: 'A Survey of the Old Testament',
              bookDescription: `This 24 lesson Survey of the Old Testament includes an outline of each Old Testament book, background information for each book, and questions for individual study. Learners who complete this course are encouraged to lead Bible studies in any Old Testament book. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/a-survey-of-the-old-testament-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/20',
              buyHardCopyLink: 'http://thebp.net/83566',
              samplePDFLink:
                '../../../assets/Pdf/a-survey-of-the-old-testament.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a study leader who carefully prepares the lesson each week prior to the group meeting.',
            },
          },
          {
            bookPageID: '2ASHJGC',
            linkName: 'how-to-study-the-bible',
            name: 'How to Study the Bible',
            linkUrl: '',
            linkDescription:
              ' (24 lessons). Using the book of Ephesians, learners will gain an in-depth experience in the inductive method of Bible study. In the course of this study they will develop 10 lesson outlines. Learners will be equipped to lead their 10 Bible studies of the book of Ephesians, as well as use this inductive method with other books of the Bible.',
            bookDetails: {
              bookHeading: 'How to Study the Bible',
              bookDescription: `This 24 lesson course teaches the inductive method of Bible study. It will enable learners develop and lead their own Bible studies. How to Study the Bible provides an inductive study of of the New Testament book of Ephesians. By using each of the inductive steps to Bible study learners will develop 10 Bible studies in the book of Ephesians, and will teach this to others. It is  is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/how-to-study-the-bible-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: true,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/13',
              buyHardCopyLink: 'http://thebp.net/13391',
              samplePDFLink: '../../../assets/Pdf/how-to-study-the-bible.pdf',
              leaderBuyHardCopyLink: 'http://thebp.net/16938',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-how-to-study-the-bible.pdf',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a qualified leader, who has studied both the lesson for the week, and the lesson guidance provided in the Leader’s Guide.',
            },
          },
        ],
      },
    },

    {
      moduleId: 'ZRTG2245F',
      mainModuleName: 'pastoral-ministry-track',
      detailpage: {
        Heading: 'Pastoral Ministry Track',
        Id:5,
        Data: `<p>In the Pastoral Ministry Track the pastor-in-training is both involved in ministry while continuing to studying lead &nbsp;iTIM courses.</p>
        <p>After completing the three Discipleship Track courses, the three Bible Teaching Track courses, plus the following three Pastoral Track courses, a Diploma in Pastoral Ministry may be awarded.</p>`,
        links: [
          {
            bookPageID: '2ASHJ6T',
            linkName: 'preparing-to-preach',
            name: 'Preparing to Preach',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) teaches and illustrates the several elements of the sermon, and helps learners develop (and preach) their own sermon from each of these three types. Outcome: Learners will complete three sermon outlines, and preach one sermon from each: topical, textual, and expository.',
            bookDetails: {
              bookHeading: 'Preparing to Preach',
              bookDescription: `Preparing to Preach is a practical “hands on” course on homiletics. The elements of sermon preparation are taught and illustrated in this 12 lesson course. Learners will also be given the opportunity to preach one message of each sermon type: topical, textual, and expository. Preparing to Preach is designed to equip bi-vocational pastors for a more effective preaching ministry. It is designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/preparing-to-preach-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/17',
              buyHardCopyLink: 'http://thebp.net/29177',
              samplePDFLink: '../../../assets/Pdf/preparing-to-preach.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who carefully prepares each weekly lesson.',
            },
          },
          {
            bookPageID: '2ASHJGD',
            linkName: 'a-panorama-of-christian-history',
            name: 'A Panorama of Christian History',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) provides a “big picture” view of the Church, from the 1st through the 20th century. It also emphasizes practical lessons that can be applied to one’s own ministry. Outcome: Learners will be challenged to teach this course to another person or group.',
            bookDetails: {
              bookHeading: 'A Panorama of Christian History',
              bookDescription: `This 12 lesson course in Church history takes learners through the history of the Christian Church from the 1st century through the 20th. A Panorama of Christian History is designed for group study in the iTIM series of equipping courses.  It requires the personal study of each lesson of an hour or more. This is followed by participation in a weekly group interaction and personal application of the lesson.  Learners who take this course are equipped to teach basic Church history in a local church setting.`,
              bookImageURl:
                '../../../assets/images/a-panorama-of-christian-history-1-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/18',
              buyHardCopyLink: 'http://thebp.net/11820',
              samplePDFLink:
                '../../../assets/Pdf/a-panorama-of-christian-history.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: ' iTIM courses call for about an hour’s personal study for each lesson. Following this this personal study, there is a weekly discussion with other iTM learners who are also taking this course. This group study should be led by an iTIM Study Leader who has carefully studied the lesson for the week.',
            },
          },
          {
            bookPageID: '2ASHJAD',
            linkName: 'contending-for-the-faith',
            name: 'Contending for the Faith',
            linkUrl: '',
            linkDescription:
              ' (12 lessons) is apologetics in action. Outcome: Learners will be enabled to defend their faith in an intellectual world, and lead non-believers to faith in Christ.',
            bookDetails: {
              bookHeading: 'Contending for the Faith',
              bookDescription: `This 12 lesson course will help learners defend and share their faith with people who are intellectually inclined.  Contending for the Faith is designed for one hour in personal study per lesson, then  group interaction and application. Learners who compete this course are prepared to engage in an apologetic ministry. It is  designed for group study in the iTIM series of equipping courses.`,
              bookImageURl:
                '../../../assets/images/contending-for-the-faith-202x300.jpg',
              isEnrollOnline: true,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: 'https://onlinecourses.traininginministry.com/course-detail/21',
              buyHardCopyLink: 'http://thebp.net/12006',
              samplePDFLink: '../../../assets/Pdf/contending-for-the-faith.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM courses call for about an hour’s personal study for each lesson. Along with this personal study, there should be a weekly discussion with others who are also taking the course. This group study should be led by a leader, who has studied well the lesson for the week,',
            },
          },
        ],
      },
    },
  ];

  public Itiministryspanish = [
    {
      moduleId: 'ZRTG224SP',
      mainModuleName: 'spanish-translations',
      detailpage: {
        Heading: 'herramientas ministerio cristiano en español',
        Data: '',
        links: [
          {
            bookPageID: '2ASHJ6T',
            linkName: 'christianity-101',
            name: 'Cristianismo Básico',
            linkUrl: '',
            linkDescription:
              'está diseñado para discipular a los nuevos cristianos, ya sea en pequeños grupos, o uno-a-uno. También es una herramienta equipamiento para permitir a otros a involucrarse en un ministerio de uno a uno discipulado.',
            bookDetails: {
              bookHeading: 'Cristianismo Básico',
              bookDescription: `Este curso de 12 lecciones es un curso de discipulado para nuevos creyentes. Cubre los fundamentos de la fe cristiana en el contexto del papel de la iglesia local. Cristianismo 101 está diseñado para el estudio personal, más la interacción grupal y la aplicación. También se puede utilizar en el estudio personal solo.`,
              bookImageURl: '../../../assets/images/C101-ES-694x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'https://app.thebookpatch.com/BookStore/christianismo-basico/f2d19ff1-53fd-4c53-a1c2-1301a967682e',
              samplePDFLink: '',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: ' iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2ASH54D',
            linkName: 'a-panorama-of-the-bible',
            name: 'Un Panorama De La Biblia',
            linkUrl: '',
            linkDescription:
              'cuenta con fácil de recordar visuales para cada uno de los 12 períodos de la Biblia. Estudiantes emocionarán a medida que aprenden y recuerdan el cuadro grande de contenido y el mensaje de la Biblia.',
            bookDetails: {
              bookHeading: 'Un Panorama De La Biblia',
              bookDescription: `Este curso de 12 lecciones proporcionará alumnos con el “cuadro grande” del contenido de la Biblia, usando fáciles de recordar símbolos para ayudar a recuperar el contenido de cada período Biblia. El autor es Earl McQuay, ex Decano de Asuntos Estudiantiles y profesor de Teología Pastoral en la Universidad Internacional de Columbia. Un Panorama de la Biblia está diseñado para el estudio personal, más la interacción grupal y la aplicación. También se puede utilizar para único estudio personal. `,
              bookImageURl: '../../../assets/images/Panorama-ES-695x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360394',
              samplePDFLink: '../../../assets/Pdf/Un-Panorama-de-la-Biblia.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AS54AD',
            linkName: 'learning-to-serve-es',
            name: 'Aprediendo A Servir: Jesús Como Modelo A Seguir',
            linkUrl: '',
            linkDescription:
              'enseña el estilo de vida de siervo de Jesús. Resultado: Este estudio ayudará a los participantes a poner en práctica el liderazgo de servicio.',
            bookDetails: {
              bookHeading: 'Aprediendo A Servir: Jesús Como Modelo A Seguir',
              bookDescription: `Este curso de 12 lecciones enseña el estilo de vida de siervo de Jesús y anima a los alumnos a modelar a Jesús en su propio estilo de vida y ministerio. Aprendiendo a servir: Jesús como modelo a seguir está diseñado para el estudio personal más la interacción y aplicación en grupo. Está diseñado para el estudio en grupo en la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/Learning-to-Serve-ES-694x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/348630',
              samplePDFLink:
                '../../../assets/Pdf/Aprendiendo-a-Servir-Jesus-Como-Modelo-a-Seguir.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AS85AD',
            linkName: 'outreach-as-a-lifestyle-es',
            name: 'El Alcance Como un Estilo de Vida',
            linkUrl: '',
            linkDescription:
              'Entrenará a los alumnos para desarrollar amistades con personas que los llevarán a compartir a Cristo con ellos. Resultado: Los alumnos incorporarán este enfoque de evangelización en su vida y ministerio diarios.',
            bookDetails: {
              bookHeading: 'El Alcance Como un Estilo de Vida',
              bookDescription: `El alcance como estilo de vida lleva a los alumnos a construir relaciones con las personas que a su vez conducen al intercambio efectivo de las Buenas Nuevas de Cristo. Este curso de 12 lecciones requiere una hora por lección de estudio individual, seguida de una interacción grupal semanal y la aplicación de la lección. Es parte de la serie iTIM de cursos de equipamiento.`,
              bookImageURl: '../../../assets/images/Outreach-ES-693x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360399',
              samplePDFLink:
                '../../../assets/Pdf/Alcance-Como-un-Estilo-de-Vida.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AS59AD',
            linkName: 'how-to-discover-your-spiritual-gifts-es',
            name: 'Cómo Descubrir Sus Dones Espirituales',
            linkUrl: '',
            linkDescription:
              'Es un estudio de los dones espirituales enseñados en el Nuevo Testamento. Resultado: Los alumnos descubrirán o tendrán más confianza en sus propios dones, y cómo y dónde usarlos al servicio de Cristo.',
            bookDetails: {
              bookHeading: 'Cómo Descubrir Sus Dones Espirituales',
              bookDescription: `Este curso de 12 lecciones ayudará a los alumnos a comprender los dones espirituales mencionados en la Biblia y a descubrir los dones que se les han dado. Los alumnos deben comprometerse a una hora de estudio personal de cada lección, seguida de una discusión y aplicación grupal. Los alumnos buscarán oportunidades para desarrollar aún más sus dones y utilizarlos para los propósitos de Dios.`,
              bookImageURl:
                '../../../assets/images/Spiritual-Gifts-ES-695x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360423',
              samplePDFLink:
                '../../../assets/Pdf/Como-Descubrir-Tus-Regalos-Espirituales.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AS79AD',
            linkName: 'welcome-to-your-ministry-es',
            name: 'Bienvenido a Su Ministerio',
            linkUrl: '',
            linkDescription:
              'Enseña a los alumnos que Dios ha dado a todos los creyentes el título y los recursos de un ministro, y los ha llamado a involucrarse en el ministerio en ya través de la iglesia. Resultado: Los alumnos serán desafiados a convertirse en buenos mayordomos de su tiempo y talentos y estarán mejor equipados para servir a Cristo.',
            bookDetails: {
              bookHeading: 'Bienvenido a Su Ministerio',
              bookDescription: `Este curso de 12 lecciones enseña la importante verdad de que Dios llama a todos los cristianos al ministerio y anima su participación en el ministerio. Bienvenido a Tu Ministerio está diseñado para una hora de estudio personal por lección, seguida de la participación en una reunión de grupo semanal que presenta la discusión y aplicación de la lección. Es uno de la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/Welcome-to-Ministry-ES-693x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360422',
              samplePDFLink:
                '../../../assets/Pdf/Bienvenido-a-Tu-Ministerio.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AG74AD',
            linkName: 'your-ministry-at-home-es',
            name: 'Su Ministerio en Casa',
            linkUrl: '',
            linkDescription:
              'Proporciona principios prácticos sobre cómo establecer y mantener un hogar cristiano. Resultado: Los alumnos aplicarán los principios dentro de la familia del alumno y guiarán a otros a través de este curso.',
            bookDetails: {
              bookHeading: 'Su Ministerio en Casa',
              bookDescription: `Este curso de 12 lecciones proporciona una gran cantidad de sugerencias de “cómo hacer” con respecto a los diversos temas de cómo debe ser un hogar cristiano. Este curso de 12 lecciones está diseñado para una hora de estudio personal por lección, seguida de una reunión grupal semanal de interacción y aplicación grupal. Es parte de la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/Your-ministry-at-home-es-688x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360434',
              samplePDFLink: '../../../assets/Pdf/Tu-Ministerio-en-Su-Casa.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: ' iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AG74AD',
            linkName: 'christianity-in-the-workplace-es',
            name: 'Cristianismo en el Lugar de Trabajo',
            linkUrl: '',
            linkDescription:
              'Relaciona la fe con cuestiones éticas y prácticas en el trabajo. Su enfoque es cómo reflejar a Cristo en su mundo laboral. Resultado: Los alumnos aplicarán estos principios bíblicos a sus áreas de trabajo.',
            bookDetails: {
              bookHeading: 'Cristianismo en el Lugar de Trabajo',
              bookDescription: `El cristianismo en el lugar de trabajo relaciona la fe con los muchos problemas éticos y prácticos que a menudo se experimentan en el mundo del trabajo. Este curso ayudará a los alumnos a ser como Cristo en su entorno laboral. Este curso de 12 lecciones está diseñado para el estudio personal más la interacción y aplicación grupal. Una Guía del líder está disponible para el estudio en grupo. Está diseñado para el estudio en grupo en la serie iTIM de cursos de preparación.`,
              bookImageURl: '../../../assets/images/Workplace-ES-694x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360489',
              samplePDFLink:
                '../../../assets/Pdf/Cristianismo-en-el-Lugar-de-Trabajo.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AG87AD',
            linkName: 'touching-tomorrow-es',
            name: 'Tocar el Mañana Enseñando a los Niños',
            linkUrl: '',
            linkDescription:
              'Entrenará obreros para servir en el emocionante y gratificante ministerio de enseñar a los niños. Resultado: Los alumnos aplicarán las enseñanzas de este curso enseñando a los niños en la Escuela Dominical y en otras oportunidades de enseñanza.',
            bookDetails: {
              bookHeading: 'Tocar el Mañana Enseñando a los Niños',
              bookDescription: `Este curso de 12 semanas es un curso de capacitación superior para equipar a los trabajadores para que enseñen las habilidades básicas para enseñar a los niños, lo que incluye ayudar a los niños a conocer a Cristo personalmente y caminar con él. El autor Wes Haystead es el editor principal de Gospel Light Publications. Touching Tomorrow by Teaching Children está diseñado para el estudio personal más la interacción y aplicación grupal. También se puede usar solo para el estudio personal. Para descargar este curso, haga clic en una de las opciones a continuación. También puede descargar una Guía del líder para este curso.`,
              bookImageURl: '../../../assets/images/Touching-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360433',
              samplePDFLink:
                '../../../assets/Pdf/tocar-el-manana-por-ensenando-a-los-ninos.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: ' iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AG97AD',
            linkName: 'your-ministry-of-prayer-es',
            name: 'Su Ministerio de Oración',
            linkUrl: '',
            linkDescription:
              'Estudia la oración en las Escrituras y guiará a los alumnos a un importante ministerio de oración. Resultado: Los alumnos se comprometerán a un ministerio de oración significativo y continuo.',
            bookDetails: {
              bookHeading: 'Su Ministerio de Oración',
              bookDescription: `Su Ministerio de Oración ayudará a los alumnos a comprender mucho más sobre el propósito y el poder de la oración, y los pondrá en el curso de un ministerio de oración significativo. Este curso de 12 lecciones está diseñado para una hora de estudio personal por lección, seguida de interacción y aplicación grupal. Es parte de la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/Your-Ministry-of-Prayer-ES-688x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360432',
              samplePDFLink:
                '../../../assets/Pdf/a-panorama-of-the-bible-es.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AH77AD',
            linkName: 'equipping-for-leadership-es',
            name: 'Equipando para el Liderazgo',
            linkUrl: '',
            linkDescription:
              'Entrenará para el liderazgo más eficaz en el ministerio de la iglesia.',
            bookDetails: {
              bookHeading: 'Equipando para el Liderazgo',
              bookDescription: `Este curso de 12 lecciones entrenará para el liderazgo más eficaz en la iglesia, y en otros lugares. Clyde McDowell, D.Min, era un ex pastor y Presidente del Seminario de Denver. Equipando para el Liderazgo está diseñado para el estudio personal, más la interacción grupal y la aplicación. También puede ser utilizado para el estudio personal solo.`,
              bookImageURl:
                '../../../assets/images/Leaadership-ES-693x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360494',
              samplePDFLink:
                '../../../assets/Pdf/equipando-para-el-liderazgo.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AH84AD',
            linkName: 'truths-that-transform-es',
            name: 'Verdad que Transforma',
            linkUrl: '',
            linkDescription:
              'Este curso de 12 lecciones proporciona una base sólida en las principales doctrinas bíblicas. También enfatiza las aplicaciones prácticas de estas verdades. La verdad que transforma está diseñada para el estudio personal, seguido de una reunión semanal de interacción y aplicación grupal.',
            bookDetails: {
              bookHeading: 'Verdad que Transforma',
              bookDescription: `Este curso de 12 lecciones sobre el liderazgo de la iglesia capacitará a los líderes de la iglesia y a los posibles líderes de la iglesia para un ministerio más efectivo en la iglesia. Equiping for Leadership está diseñado para una hora de estudio personal por lección, más una reunión de grupo iTIM semanal. Los alumnos que completen este curso serán más efectivos en su ministerio de liderazgo en la iglesia. Está diseñado para el estudio en grupo en la serie iTIM de cursos de equipamiento.`,
              bookImageURl: '../../../assets/images/Truth-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360436',
              samplePDFLink: '../../../assets/Pdf/La-Verdad-Que-Transforma.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AT58AD',
            linkName: 'old-testament-survey-es',
            name: 'Una Encuesta del Antiguo Testamento',
            linkUrl: '',
            linkDescription:
              'Incluye información básica, la idea principal de cada libro, un resumen de cada libro y preguntas de valor práctico y espiritual. Resultado: Los alumnos estarán equipados para dirigir estudios bíblicos en cualquier libro del Antiguo Testamento.',
            bookDetails: {
              bookHeading: 'Una Encuesta del Antiguo Testamento',
              bookDescription: `Este Resumen de 24 lecciones del Antiguo Testamento incluye un bosquejo de cada libro del Antiguo Testamento, información de trasfondo para cada libro y preguntas para el estudio individual. Se alienta a los alumnos que completan este curso a dirigir estudios bíblicos en cualquier libro del Antiguo Testamento. Está diseñado para el estudio en grupo en la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/Old-Testament-Survey-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360442',
              samplePDFLink:
                '../../../assets/Pdf/Encuesta-de-a-Antiguo-Testmento.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2Ap58AD',
            linkName: 'new-testament-survey-es',
            name: 'Una Encuesta del Nuevo Testamento',
            linkUrl: '',
            linkDescription:
              'Incluye información básica, la idea principal de cada libro, un resumen de cada libro y preguntas de valor práctico y espiritual. Resultado: Los alumnos estarán equipados para dirigir estudios bíblicos en cualquier libro del Nuevo Testamento.',
            bookDetails: {
              bookHeading: 'Una Encuesta del Nuevo Testamento',
              bookDescription: `Este Estudio del Nuevo Testamento de 24 lecciones incluye bosquejos básicos de cada libro, información de trasfondo para cada libro y preguntas para responder. Los alumnos que completen este estudio estarán calificados para dirigir estudios bíblicos en cualquier libro del Nuevo Testamento. Está diseñado para el estudio en grupo en la serie iTIM de cursos de equipamiento.`,
              bookImageURl:
                '../../../assets/images/New-Testament-Survey-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360445',
              samplePDFLink:
                '../../../assets/Pdf/Encuesta-de-a-Nuevo-Testmento.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AL88AD',
            linkName: 'how-to-study-the-bible-es',
            name: 'Cómo Estudiar la Biblia',
            linkUrl: '',
            linkDescription:
              'Dará a los estudiantes una exposición en profundidad para el método inductivo de estudio bíblico y ayudarles a desarrollar sus propios esquemas de los principales estudios de la Biblia.',
            bookDetails: {
              bookHeading: 'Cómo Estudiar la Biblia',
              bookDescription: `Este curso de 24 lecciones ofrece una exposición en profundidad para el método inductivo de estudio de la Biblia y ayudará a los estudiantes a desarrollar y conducir sus propios estudios bíblicos. Cómo estudiar la Biblia está diseñado tanto para el estudio personal y la interacción grupal y la aplicación. También se puede utilizar en el estudio personal solo. `,
              bookImageURl:
                '../../../assets/images/How-to-Study-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: false,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: true,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360446',
              samplePDFLink: '../../../assets/Pdf/Como-Estudiar-La-Biblia.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink:
                '../../../assets/Pdf/lg-how-to-study-the-bible-es.pdf',
              note: ' iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AM78AD',
            linkName: 'contending-for-the-faith-es',
            name: 'Luchando por la Fe',
            linkUrl: '',
            linkDescription:
              'Es apologética en acción. Resultado: Los alumnos podrán defender su fe en un mundo intelectual y guiar a los no creyentes a la fe en Cristo.',
            bookDetails: {
              bookHeading: 'Luchando por la Fe',
              bookDescription: `Este curso de 12 lecciones ayudará a los alumnos a defender y compartir su fe con personas intelectualmente inclinadas. Contender por la fe está diseñado para una hora de estudio personal por lección, luego interacción grupal y aplicación. Los alumnos que completan este curso están preparados para participar en un ministerio apologético. Está diseñado para el estudio en grupo en la serie iTIM de cursos de equipamiento.`,
              bookImageURl: '../../../assets/images/Contending-ES-691x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360482',
              samplePDFLink: '../../../assets/Pdf/Contendiendo-Por-la-Fe.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AF63AD',
            linkName: 'preparing-to-preach-es',
            name: 'Preparándose para Predicar',
            linkUrl: '',
            linkDescription:
              'Enseña e ilustra los diversos elementos del sermón y ayuda a los alumnos a desarrollar (y predicar) su propio sermón de cada uno de estos tres tipos. Resultado: Los alumnos completarán tres bosquejos de sermones y predicarán un sermón de cada uno: tópico, textual y expositivo.',
            bookDetails: {
              bookHeading: 'Preparándose para Predicar',
              bookDescription: `Preparándose para Predicar es un curso práctico sobre homilética. Los elementos de la preparación del sermón se enseñan e ilustran en este curso de 12 lecciones. Los alumnos también tendrán la oportunidad de predicar un mensaje de cada tipo de sermón: tópico, textual y expositivo. Preparing to Preach está diseñado para equipar a los pastores bivocacionales para un ministerio de predicación más efectivo. Está diseñado para el estudio en grupo en la serie iTIM de cursos de preparación.`,
              bookImageURl:
                '../../../assets/images/Preparing-to-preach-es-700x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360448',
              samplePDFLink: '../../../assets/Pdf/Preparando-Predicar.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
          {
            bookPageID: '2AD23AD',
            linkName: 'a-panoraama-of-christian-history-es',
            name: 'Un Panorama de la Historia Cristiana',
            linkUrl: '',
            linkDescription:
              'Proporciona una vista de “panorama general” de la Iglesia, desde el siglo I hasta el siglo XX. También enfatiza lecciones prácticas que se pueden aplicar al propio ministerio. Resultado: los alumnos tendrán el desafío de enseñar este curso a otra persona o grupo.',
            bookDetails: {
              bookHeading: 'Un Panorama de la Historia Cristiana',
              bookDescription: `Este curso de 12 lecciones sobre la historia de la Iglesia lleva a los alumnos a través de la historia de la Iglesia cristiana desde el siglo I hasta el siglo XX. Un panorama de la historia cristiana está diseñado para el estudio en grupo en la serie iTIM de cursos de preparación. Requiere el estudio personal de cada lección de una hora o más. A esto le sigue la participación en una interacción grupal semanal y la aplicación personal de la lección. Los alumnos que toman este curso están equipados para enseñar la historia básica de la Iglesia en el entorno de una iglesia local.`,
              bookImageURl:
                '../../../assets/images/Panorama-of-christian-history-ES-694x1024.png',
              isEnrollOnline: false,
              isBuyHardCopy: true,
              isSamplePDF: true,
              isLeaderGuidButton: true,
              isLeaderGuideHardCopy: false,
              isLeaderGuideSmaplePDF: false,
              enrollOnlineLink: '',
              buyHardCopyLink: 'http://thebp.net/360481',
              samplePDFLink:
                '../../../assets/Pdf/Una-Panorama-de-Histora-Christiana.pdf',
              leaderBuyHardCopyLink: '',
              leaderSamplePDFlink: '',
              note: 'iTIM cursos están diseñados para pequeños grupos de discusión. Los participantes deben preparar cada lección con antelación. Líderes del estudio Grupo utilizan la Guía del Líder para prepararse para la discusión en grupo de 90 minutos.',
            },
          },
        ],
      },
    },
  ];

  public Itiministryrussian = [
    {
      moduleId: 'ZRTG224SP',
      mainModuleName: 'russian-translations',
      detailpage: {
        Heading: 'Христианские инструменты служения на русском языке',
        Data: '',
        links: [
          {
            bookPageID: '13SHJ6T',
            linkName: 'christianity-101',
            name: 'Добро Пожаловать В Церковь (Christianity 101)',
            linkUrl: '',
            linkDescription:
              'предназначен для наставлять новых христиан, либо в небольших группах или один – к-одному. Это также инструмент в наличии, чтобы позволить другим участвовать в служении один -к-одному ученичества.',
            bookDetails: {
              bookHeading: 'ДОБРО ПОЖАЛОВАТЬ В ЦЕРКОВЬ',
              bookDescription: `Этот урок 12 Курс представляет собой ученичество курс для новых верующих . Она охватывает основы христианской веры в контексте роли местной церкви . Христианство 101 предназначен для личного изучения плюс группового взаимодействия и применения . Он также может быть использован только в личном изучении . Чтобы скачать этот курс , нажмите на одну из приведенных ниже вариантов . Вы также можете скачать бесплатное руководство Лидера для этого курса.`,
              bookImageURl: '../../../assets/images/christianity-101-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/christianity-101.doc',
              leaderSampleDOClink:
                '../../../assets/Doc/lg-christianity-101.doc',
              note: ' iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '14SHJ6T',
            linkName: 'a-panorama-of-the-bible',
            name: 'Ппанорама Библии (A Panorama of the Bible)',
            linkUrl: '',
            linkDescription:
              'особенности легко запоминающиеся визуальные эффекты для каждого из периодов 12 Библии . Обучающиеся острых ощущений , как они учатся и помнить большую картину содержания и сообщения Библии .',
            bookDetails: {
              bookHeading: 'Панорама Библии',
              bookDescription: `Этот урок 12 Курс предоставит учащимся “большой картины ” содержания Библии , используя простой для запоминания символов , чтобы помочь вспомнить содержание каждого периода Библии . Автор граф McQuay , бывший декан по делам студентов и профессор пастырского богословия в Колумбийском Международном университете . Панорама Библии предназначена для личного изучения плюс группового взаимодействия и применения . Он также может быть использован только для личного изучения . Чтобы загрузить этот курс , нажмите на одну из приведенных ниже вариантов . Вы также можете скачать бесплатное руководство Лидера для этого курса.`,
              bookImageURl:
                '../../../assets/images/a-panorama-of-the-bible-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/a-panorama-of-the-bible.doc',
              leaderSampleDOClink:
                '../../../assets/Doc/lg-a-panorama-of-the-bible.doc',
              note: '  iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '15SHJ6T',
            linkName: 'how-to-discover-your-spirtual-gifts',
            name: 'Ваши Духовные Дарования (How to Discover Your Spiritual Gifts)',
            linkUrl: '',
            linkDescription:
              'обеспечит верующим лучше понять из которых духовные дары, они могут иметь, и как использовать свои дары в служении Христу.',
            bookDetails: {
              bookHeading: 'ВАШИ ДУХОВНЫЕ ДАРованиЯ',
              bookDescription: `Этот урок 12 курс поможет учащимся понять духовные дары и откройте для себя ( и использовать ) дары, которые они получили. Автор, доктор Клайд Макдауэлл, был бывший пастор, а затем президент Денвер Семинарии. Как открыть свой Дарах предназначен для личного изучения плюс группового взаимодействия и применения. Он также может быть использован для одного только личного изучения. Чтобы загрузить этот курс, нажмите на одну из приведенных ниже вариантов. Вы также можете скачать бесплатное руководство Лидера для этого курса.`,
              bookImageURl:
                '../../../assets/images/how-to-discover-your-spirtual-gifts-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink:
                '../../../assets/Doc/lg-how-to-discover-your-spirtual-gifts.doc',
              leaderSampleDOClink:
                '../../../assets/Doc/how-to-discover-your-spirtual-gifts.doc',
              note: ' iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '16SHJ6T',
            linkName: 'your-ministry-of-prayer',
            name: 'Ваше Молитвенное Служение (Your Ministry of Prayer)',
            linkUrl: '',
            linkDescription:
              'изучает молитвы в Писании, и поможет учащимся принять участие в значительном молитвенном служении.',
            bookDetails: {
              bookHeading: 'ваше-молитвенное-служение',
              bookDescription: `Ваше Министерство молитвы поможет учащимся понять гораздо больше о цели и силе молитвы , и поставил их на курс значительного молитвенного служения . Гэри Уайльд был редактором Дэвид С. Кук Публикации . Этот урок 12 Курс предназначен для личного изучения плюс группового взаимодействия и применения . Он также может быть использован для одного только личного изучения . Чтобы загрузить этот курс , нажмите на одну из приведенных ниже вариантов . Вы также можете скачать бесплатное руководство Лидера для этого курса.`,
              bookImageURl:
                '../../../assets/images/your-ministry-of-prayer-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/your-ministry-of-prayer.doc',
              leaderSampleDOClink:
                '../../../assets/Doc/lg-your-ministry-of-prayer.doc',
              note: '  iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '17SHJ6T',
            linkName: 'your-ministry-at-home',
            name: 'Ваше Служение Дома (Your Ministry at Home)',
            linkUrl: '',
            linkDescription:
              'содержит много практических принципов в том, как создать и поддерживать истинно христианский дом.',
            bookDetails: {
              bookHeading: 'ВАШЕ СЛУЖЕНИЕ ДОМА',
              bookDescription: `Этот урок 12 Курс обеспечивает богатство “как” предложения относительно различных аспектов того, что христианский дом выглядеть. Автор, Марианн Саммс, M.A., является матерью пяти взрослых детей и учил христианское образование как на Филиппинах и в США 12 Этот урок курс предназначен для личного изучения плюс группового взаимодействия и применения. Он также может быть использован для одного только личного изучения. Чтобы загрузить этот курс, нажмите на одну из приведенных ниже вариантов. Вы также можете скачать Руководство лидером для этого курса.`,
              bookImageURl:
                '../../../assets/images/your-ministry-at-home-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/your-ministry-at-home.doc',
              leaderSampleDOClink: '',
              note: ' iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '18SHJ6T',
            linkName: 'how-to-study-the-bible',
            name: 'Как изучать Библию (How to Study the Bible)',
            linkUrl: '',
            linkDescription:
              'даст студентам глубокое воздействие на индуктивный метод изучения Библии и помочь им развить свои собственные контуры для ведущих изучения Библии.',
            bookDetails: {
              bookHeading: 'Как изучать Библию',
              bookDescription: `Этот урок 24 Курс обеспечивает углубленное воздействие индуктивный метод изучения Библии и поможет учащимся разрабатывать и вести свои собственные занятия по изучению Библии. Как изучать Библию предназначен как для личного изучения и группового взаимодействия и применения. Он также может быть использован только в личном изучении. Чтобы загрузить этот курс, нажмите на одну из приведенных ниже вариантов. Вы также можете скачать Руководство лидером для этого курса.`,
              bookImageURl:
                '../../../assets/images/how-to-study-the-bible-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/how-to-study-the-bible',
              leaderSampleDOClink:
                '../../../assets/Doc/lg-how-to-study-the-bible.doc',
              note: '  iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '19SHJ6T',
            linkName: 'truth-that-transforms',
            name: 'ПреображающаЯ истина (Truth That Transforms)',
            linkUrl: '',
            linkDescription:
              'предоставит учащимся прочную основу в основных доктрин Писания, с акцентом на практическое применение.',
            bookDetails: {
              bookHeading: 'ПреображающаЯ истина',
              bookDescription: `Этот урок 12 Курс обеспечивает прочную основу в основных библейских доктрин, и подчеркивает практическое применение этих истин. Истина, которая Трансформации предназначена для личного изучения плюс группового взаимодействия и применения. Он также может быть использован только в личном изучении. Чтобы загрузить этот курс, нажмите на одну из приведенных ниже вариантов. Вы также можете скачать Руководство Лидера для этого курса.`,
              bookImageURl:
                '../../../assets/images/truth-that-transforms-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: false,
              isLeaderGuideSmapleDOC: true,
              sampleDOCLink: '../../../assets/Doc/truth-that-transforms-2.doc',
              leaderSampleDOClink:
                '../../../assets/Doc/lg-truth-that-transforms-2.doc',
              note: ' iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
          {
            bookPageID: '14SHJ6T',
            linkName: 'contending-for-the-faith',
            name: 'Борьба за веру (Contending for the Faith)',
            linkUrl: '',
            linkDescription:
              'это курс по христианской апологетике, которые будут оснащать учеников защищать и делиться своей верой, особенно среди интеллектуальных неверующими.',
            bookDetails: {
              bookHeading: 'Борьба за веру',
              bookDescription: ``,
              bookImageURl:
                '../../../assets/images/contending-for-the-faith-2.jpg',
              isSampleDOC: true,
              isLeaderGuidButton: true,
              isLeaderGuideSmapleDOC: false,
              sampleDOCLink: '../../../assets/Doc/contending-for-the-faith.doc',
              leaderSampleDOClink: '',
              note: '  iTIM курсы требуют личного изучения около часа для каждого урока . Наряду с этим личный кабинет, там должно быть еженедельным обсуждение с другими, которые также берут курс. Эта группа исследование должно осуществляться под руководством квалифицированного руководителя, который изучил как урок в течение недели, и материал в руководстве Вождя.',
            },
          },
        ],
      },
    },
  ];

  public getAllModule() {
    return this.itimMinistryTracks.map((m) => {
      return m.mainModuleName;
    });
  }

  public getModuleByModuleName(moduleName) {
    return this.itimMinistryTracks.find((x) => x.mainModuleName == moduleName);
  }

  public getBookByModule(moduleName, link) {
    var module = this.getModuleByModuleName(moduleName);
    return module.detailpage.links.find((x) => x.linkName == link);
  }

  public getspanishModuleByModuleName(moduleName) {
    return this.Itiministryspanish.find((x) => x.mainModuleName == moduleName);
  }
  public getspanishBookByModule(moduleName, link) {
    var module = this.getspanishModuleByModuleName(moduleName);
    return module.detailpage.links.find((x) => x.linkName == link);
  }

  public getrussianModuleByModuleName(moduleName) {
    return this.Itiministryrussian.find((x) => x.mainModuleName == moduleName);
  }
  public getrussianBookByModule(moduleName, link) {
    var module = this.getrussianModuleByModuleName(moduleName);
    return module.detailpage.links.find((x) => x.linkName == link);
  }
}
